import { ImageFit, PrimaryButton, Stack, Image, TextField, Text } from "@fluentui/react";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CommonFunctions } from "../../../ApplicationCode/Common/CommonFunctions";
import logo from '../../../Assets/Images/logoSoSmart.png';
import { MessageType, ToastService } from "../../../Core/Toast/ToastService";
import { Loader } from "../Loader/Loader";
import { SystemDataLoadingStatus } from "../../../Model/SystemModels";
import { t } from "i18next";
import { SystemCore } from "../../../Core/System/SystemCore";
import { useBreakpoint } from "../Container/ContainerStyles";
import { BreakpointType } from "../Container/ContainerFluid";
import { lgLoginBoxContainer, lgLoginBoxTextFieldStyles, lgLoginButtonStyles, lgSubTitleStyles, lgTitleStyles, loginBoxContainer, loginBoxPageContainer, loginBoxTextFieldStyles, loginButtonStyles, loginLogoContainer, mdLoginBoxContainer, mdLoginBoxTextFieldStyles, mdLoginButtonStyles, mdSubTitleStyles, mdTitleStyles, privateFormContainer, smLoginBoxContainer, smLoginBoxTextFieldStyles, smLoginButtonStyles, smSubTitleStyles, smTitleStyles, subTitleStyles, titleStyles, xlLoginBoxContainer, xlLoginBoxTextFieldStyles, xlLoginButtonStyles, xlSubTitleStyles, xlTitleStyles, xxlLoginBoxContainer, xxlLoginBoxTextFieldStyles, xxlLoginButtonStyles, xxlSubTitleStyles, xxlTitleStyles } from "../LoginBox/Styles/LoginBoxStyles";

export const ForgotPasswordBox : React.FC = () => {
    const [dataStatus, setDataStatus] = useState(SystemDataLoadingStatus.ToLoad);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [hash, setHash] = useState("");
    const [email, setEmail] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    
    const isSM = useBreakpoint(BreakpointType.sm);
    const isMD = useBreakpoint(BreakpointType.md);
    const isLG = useBreakpoint(BreakpointType.lg);
    const isXL = useBreakpoint(BreakpointType.xl);
    const isXXL = useBreakpoint(BreakpointType.xxl);

    useEffect(() => {
        setDataStatus(SystemDataLoadingStatus.Loading);        
        const currentParams = new URLSearchParams(location.search);
        let email = currentParams.get("email");
        if (email)
            setEmail(atob(email));

        checkHashParameter();
    }, []);
    
    const checkHashParameter = () => {
        var url = new URL(window.location.toString());
        var hash = url.searchParams.get("hash");

        if (hash != null)
        {
            window.history.replaceState(null, '', window.location.pathname);

            CommonFunctions.checkHashParameter(hash!)
                .then(() => {
                    setHash(hash!);
                })
                .catch(() => {
                    ToastService.showMessage(MessageType.Error, t('common:ForgotPasswordBox:Err00001Text')!);
                    navigate("/login");
                })
                .finally(() => {
                    setDataStatus(SystemDataLoadingStatus.Loaded);
                });
        }
        else
            window.location.replace("login");
    };

    const handleOnSave = () => {
        if (!password) {
            ToastService.showMessage(MessageType.Error, t('common:ForgotPasswordBox:passwordMandatory')!);
            return;
        }

        if (password !== confirmPassword) {
            ToastService.showMessage(MessageType.Error, t('common:ForgotPasswordBox:passwordValidation')!);
            return;
        }

        setSaveInProgress(true);

        CommonFunctions.processPasswordReset(hash!, password)
            .then((resp) => {
                ToastService.showMessage(MessageType.Success, t('common:ForgotPasswordBox:passwordConfirmation')!);
                window.location.replace(resp);
            })
            .catch((err) => {
                ToastService.showMessage(MessageType.Error, err);
                setSaveInProgress(false);
            });
    }

    if (!SystemCore.isFinishedDataStatus(dataStatus))
        return (
            <Loader 
                text={t('common:ForgotPasswordBox:loaderMessage')!} 
            />
        );
    
    return (
        <Stack 
            horizontal
            verticalFill
            horizontalAlign="center"
            verticalAlign="center"
            className={loginBoxPageContainer}
        >
            <Stack
                className={
                    isSM ? 
                        smLoginBoxContainer :
                    isMD ?
                        mdLoginBoxContainer :
                    isLG ?
                        lgLoginBoxContainer :
                    isXL ?
                        xlLoginBoxContainer :
                    isXXL ?
                        xxlLoginBoxContainer
                    :
                        loginBoxContainer
                }
            >
                <Stack
                    horizontal
                    horizontalAlign="center"
                    className={loginLogoContainer}
                >
                    <Image 
                        src={logo} 
                        imageFit={ImageFit.cover}
                    />
                </Stack>
                <Stack 
                    className={privateFormContainer}
                >
                    <Stack 
                        verticalFill
                        verticalAlign="start" 
                        horizontalAlign="center"
                    >
                        <Text
                            className={
                                isSM ? 
                                    smTitleStyles :
                                isMD ?
                                    mdTitleStyles :
                                isLG ?
                                    lgTitleStyles :
                                isXL ?
                                    xlTitleStyles :
                                isXXL ?
                                    xxlTitleStyles
                                :
                                    titleStyles
                            }
                        >
                            {t('common:LoginBox:welcome')!}
                        </Text>
                        <Text
                            className={
                                isSM ? 
                                    smSubTitleStyles :
                                isMD ?
                                    mdSubTitleStyles :
                                isLG ?
                                    lgSubTitleStyles :
                                isXL ?
                                    xlSubTitleStyles :
                                isXXL ?
                                    xxlSubTitleStyles
                                :
                                    subTitleStyles
                            }
                        >
                            {t('common:ForgotPasswordBox:passwordMessage')!}
                        </Text>
                    </Stack>
                    <Stack>
                        {
                            email && 
                                <TextField
                                    label="Account"
                                    styles={
                                        isSM ? 
                                            smLoginBoxTextFieldStyles :
                                        isMD ?
                                            mdLoginBoxTextFieldStyles :
                                        isLG ?
                                            lgLoginBoxTextFieldStyles :
                                        isXL ?
                                            xlLoginBoxTextFieldStyles :
                                        isXXL ?
                                            xxlLoginBoxTextFieldStyles 
                                        :
                                            loginBoxTextFieldStyles
                                    }
                                    value={email}
                                    disabled
                                />
                            }
                    </Stack>
                    <Stack>
                        <TextField
                            type='password'
                            label={t('common:ForgotPasswordBox:passwordLabel')!}
                            styles={
                                isSM ? 
                                    smLoginBoxTextFieldStyles :
                                isMD ?
                                    mdLoginBoxTextFieldStyles :
                                isLG ?
                                    lgLoginBoxTextFieldStyles :
                                isXL ?
                                    xlLoginBoxTextFieldStyles :
                                isXXL ?
                                    xxlLoginBoxTextFieldStyles 
                                :
                                    loginBoxTextFieldStyles
                            }
                            value={password}
                            required
                            disabled={saveInProgress}
                            canRevealPassword 
                            onChange={(ev, newValue) => { 
                                setPassword(newValue!);
                            }}
                        />
                        <TextField
                            type='password'
                            label={t('common:ForgotPasswordBox:confirmPasswordLabel')!}
                            styles={
                                isSM ? 
                                    smLoginBoxTextFieldStyles :
                                isMD ?
                                    mdLoginBoxTextFieldStyles :
                                isLG ?
                                    lgLoginBoxTextFieldStyles :
                                isXL ?
                                    xlLoginBoxTextFieldStyles :
                                isXXL ?
                                    xxlLoginBoxTextFieldStyles 
                                :
                                    loginBoxTextFieldStyles
                            }
                            value={confirmPassword}
                            required
                            disabled={saveInProgress}
                            canRevealPassword
                            onChange={(ev, newValue) => { 
                                setConfirmPassword(newValue!);
                            }}
                        />
                    </Stack>
                    <Stack>
                        <PrimaryButton
                            type="submit"
                            text={t('common:ForgotPasswordBox:confirmButtonLabel')!} 
                            styles={
                                isSM ? 
                                    smLoginButtonStyles :
                                isMD ?
                                    mdLoginButtonStyles :
                                isLG ?
                                    lgLoginButtonStyles :
                                isXL ?
                                    xlLoginButtonStyles :
                                isXXL ?
                                    xxlLoginButtonStyles
                                :
                                    loginButtonStyles
                            } 
                            disabled={saveInProgress} 
                            toggle 
                            allowDisabledFocus
                            onClick={handleOnSave}
                        />
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
}